@file:OptIn(InternalResourceApi::class)

package diana.soleil.design.iraniancanadienbazzar.feature.business.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String =
    "composeResources/diana.soleil.design.iraniancanadienbazzar.feature.business.resources/"

@delegate:ResourceContentHash(-1_907_480_115)
internal val Res.string.all_photos_empty: StringResource by lazy {
      StringResource("string:all_photos_empty", "all_photos_empty", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 140, 80),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 128, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 132, 44),
      ))
    }

@delegate:ResourceContentHash(923_613_815)
internal val Res.string.all_photos_title: StringResource by lazy {
      StringResource("string:all_photos_title", "all_photos_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 221, 44),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 193, 32),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 177, 32),
      ))
    }

@delegate:ResourceContentHash(-1_145_252_665)
internal val Res.string.all_reviews_count: StringResource by lazy {
      StringResource("string:all_reviews_count", "all_reviews_count", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 266, 41),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 226, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 210, 41),
      ))
    }

@delegate:ResourceContentHash(-964_082_059)
internal val Res.string.all_reviews_sort_highest: StringResource by lazy {
      StringResource("string:all_reviews_sort_highest", "all_reviews_sort_highest", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 308, 68),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 264, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 252, 52),
      ))
    }

@delegate:ResourceContentHash(316_326_826)
internal val Res.string.all_reviews_sort_lowest: StringResource by lazy {
      StringResource("string:all_reviews_sort_lowest", "all_reviews_sort_lowest", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 377, 67),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 313, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 305, 47),
      ))
    }

@delegate:ResourceContentHash(1_775_077_881)
internal val Res.string.all_reviews_sort_recent: StringResource by lazy {
      StringResource("string:all_reviews_sort_recent", "all_reviews_sort_recent", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 445, 55),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 369, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 353, 47),
      ))
    }

@delegate:ResourceContentHash(-1_842_427_983)
internal val Res.string.all_reviews_title: StringResource by lazy {
      StringResource("string:all_reviews_title", "all_reviews_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 501, 41),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 421, 33),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 401, 37),
      ))
    }

@delegate:ResourceContentHash(-1_156_096_326)
internal val Res.string.biz_lang_arabic: StringResource by lazy {
      StringResource("string:biz_lang_arabic", "biz_lang_arabic", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 543, 35),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 455, 31),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 439, 31),
      ))
    }

@delegate:ResourceContentHash(891_042_751)
internal val Res.string.biz_lang_english: StringResource by lazy {
      StringResource("string:biz_lang_english", "biz_lang_english", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 579, 44),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 487, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 471, 36),
      ))
    }

@delegate:ResourceContentHash(1_735_552_202)
internal val Res.string.biz_lang_french: StringResource by lazy {
      StringResource("string:biz_lang_french", "biz_lang_french", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 624, 43),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 524, 35),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 508, 31),
      ))
    }

@delegate:ResourceContentHash(135_423_525)
internal val Res.string.biz_lang_persian: StringResource by lazy {
      StringResource("string:biz_lang_persian", "biz_lang_persian", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 668, 40),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 560, 32),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 540, 36),
      ))
    }

@delegate:ResourceContentHash(1_374_753_224)
internal val Res.string.business_action_call: StringResource by lazy {
      StringResource("string:business_action_call", "business_action_call", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 709, 40),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 593, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 577, 36),
      ))
    }

@delegate:ResourceContentHash(-961_078_502)
internal val Res.string.business_action_chat: StringResource by lazy {
      StringResource("string:business_action_chat", "business_action_chat", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 750, 48),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 634, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 614, 36),
      ))
    }

@delegate:ResourceContentHash(1_264_996_664)
internal val Res.string.business_action_details: StringResource by lazy {
      StringResource("string:business_action_details", "business_action_details", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 799, 47),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 679, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 651, 43),
      ))
    }

@delegate:ResourceContentHash(362_912_612)
internal val Res.string.business_action_directions: StringResource by lazy {
      StringResource("string:business_action_directions", "business_action_directions", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 847, 46),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 723, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 695, 50),
      ))
    }

@delegate:ResourceContentHash(-1_742_868_502)
internal val Res.string.business_action_see_all: StringResource by lazy {
      StringResource("string:business_action_see_all", "business_action_see_all", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 894, 51),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 774, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 746, 43),
      ))
    }

@delegate:ResourceContentHash(-1_731_035_002)
internal val Res.string.business_action_view_all: StringResource by lazy {
      StringResource("string:business_action_view_all", "business_action_view_all", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 946, 52),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 818, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 790, 44),
      ))
    }

@delegate:ResourceContentHash(1_609_984_747)
internal val Res.string.business_action_view_menu: StringResource by lazy {
      StringResource("string:business_action_view_menu", "business_action_view_menu", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 999, 53),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 863, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 835, 45),
      ))
    }

@delegate:ResourceContentHash(-1_771_510_248)
internal val Res.string.business_action_website: StringResource by lazy {
      StringResource("string:business_action_website", "business_action_website", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1053, 51),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 913, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 881, 43),
      ))
    }

@delegate:ResourceContentHash(-565_794_283)
internal val Res.string.business_add_listing_a11y: StringResource by lazy {
      StringResource("string:business_add_listing_a11y", "business_add_listing_a11y", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1105, 73),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 957, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 925, 53),
      ))
    }

@delegate:ResourceContentHash(684_562_503)
internal val Res.string.business_address_approx: StringResource by lazy {
      StringResource("string:business_address_approx", "business_address_approx", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1179, 183),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1023, 131),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 979, 103),
      ))
    }

@delegate:ResourceContentHash(-74_719_876)
internal val Res.string.business_back_a11y: StringResource by lazy {
      StringResource("string:business_back_a11y", "business_back_a11y", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1363, 42),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1155, 34),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1083, 34),
      ))
    }

@delegate:ResourceContentHash(157_111_186)
internal val Res.string.business_badge_new: StringResource by lazy {
      StringResource("string:business_badge_new", "business_badge_new", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1406, 38),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1190, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1118, 30),
      ))
    }

@delegate:ResourceContentHash(1_374_753_224)
internal val Res.string.business_call_a11y: StringResource by lazy {
      StringResource("string:business_call_a11y", "business_call_a11y", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1445, 38),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1229, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1149, 34),
      ))
    }

@delegate:ResourceContentHash(1_371_152_013)
internal val Res.string.business_channel: StringResource by lazy {
      StringResource("string:business_channel", "business_channel", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1484, 60),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1268, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1184, 48),
      ))
    }

@delegate:ResourceContentHash(1_686_337_385)
internal val Res.string.business_claim_cta: StringResource by lazy {
      StringResource("string:business_claim_cta", "business_claim_cta", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1545, 66),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1321, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1233, 50),
      ))
    }

@delegate:ResourceContentHash(404_762_477)
internal val Res.string.business_claim_desc: StringResource by lazy {
      StringResource("string:business_claim_desc", "business_claim_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1612, 355),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1384, 223),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1284, 179),
      ))
    }

@delegate:ResourceContentHash(-760_542_181)
internal val Res.string.business_claim_failed: StringResource by lazy {
      StringResource("string:business_claim_failed", "business_claim_failed", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1968, 129),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1608, 89),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1464, 89),
      ))
    }

@delegate:ResourceContentHash(-659_332_549)
internal val Res.string.business_claim_sent: StringResource by lazy {
      StringResource("string:business_claim_sent", "business_claim_sent", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 2098, 67),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1698, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1554, 51),
      ))
    }

@delegate:ResourceContentHash(-1_703_546_548)
internal val Res.string.business_claim_title: StringResource by lazy {
      StringResource("string:business_claim_title", "business_claim_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 2166, 100),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1750, 72),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1606, 52),
      ))
    }

@delegate:ResourceContentHash(1_729_585_325)
internal val Res.string.business_claim_verified_cta: StringResource by lazy {
      StringResource("string:business_claim_verified_cta", "business_claim_verified_cta", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 2267, 91),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1823, 75),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1659, 59),
      ))
    }

@delegate:ResourceContentHash(1_722_766_329)
internal val Res.string.business_claim_verified_desc: StringResource by lazy {
      StringResource("string:business_claim_verified_desc", "business_claim_verified_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 2359, 384),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1899, 280),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1719, 228),
      ))
    }

@delegate:ResourceContentHash(1_599_529_801)
internal val Res.string.business_claim_verified_title: StringResource by lazy {
      StringResource("string:business_claim_verified_title", "business_claim_verified_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 2744, 93),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2180, 81),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1948, 73),
      ))
    }

@delegate:ResourceContentHash(1_497_069_114)
internal val Res.string.business_closed: StringResource by lazy {
      StringResource("string:business_closed", "business_closed", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 2838, 35),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2262, 31),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2022, 31),
      ))
    }

@delegate:ResourceContentHash(174_435_956)
internal val Res.string.business_closes: StringResource by lazy {
      StringResource("string:business_closes", "business_closes", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 2874, 55),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2294, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2054, 39),
      ))
    }

@delegate:ResourceContentHash(1_417_037_891)
internal val Res.string.business_cover_a11y: StringResource by lazy {
      StringResource("string:business_cover_a11y", "business_cover_a11y", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 2930, 71),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2338, 75),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2094, 55),
      ))
    }

@delegate:ResourceContentHash(362_912_612)
internal val Res.string.business_directions_a11y: StringResource by lazy {
      StringResource("string:business_directions_a11y", "business_directions_a11y", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 3002, 44),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2414, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2150, 48),
      ))
    }

@delegate:ResourceContentHash(-400_174_121)
internal val Res.string.business_distance_km: StringResource by lazy {
      StringResource("string:business_distance_km", "business_distance_km", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 3047, 56),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2463, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2199, 40),
      ))
    }

@delegate:ResourceContentHash(1_658_095_410)
internal val Res.string.business_distance_m: StringResource by lazy {
      StringResource("string:business_distance_m", "business_distance_m", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 3104, 43),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2504, 35),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2240, 35),
      ))
    }

@delegate:ResourceContentHash(-949_549_443)
internal val Res.string.business_empty: StringResource by lazy {
      StringResource("string:business_empty", "business_empty", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 3148, 90),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2540, 74),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2276, 54),
      ))
    }

@delegate:ResourceContentHash(-1_716_365_713)
internal val Res.string.business_error: StringResource by lazy {
      StringResource("string:business_error", "business_error", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 3239, 98),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2615, 74),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2331, 58),
      ))
    }

@delegate:ResourceContentHash(1_835_836_002)
internal val Res.string.business_favorite_a11y: StringResource by lazy {
      StringResource("string:business_favorite_a11y", "business_favorite_a11y", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 3338, 70),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2690, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2390, 50),
      ))
    }

@delegate:ResourceContentHash(453_317_712)
internal val Res.string.business_filter_nearby: StringResource by lazy {
      StringResource("string:business_filter_nearby", "business_filter_nearby", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 3409, 46),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2753, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2441, 38),
      ))
    }

@delegate:ResourceContentHash(395_804_089)
internal val Res.string.business_filter_open_now: StringResource by lazy {
      StringResource("string:business_filter_open_now", "business_filter_open_now", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 3456, 56),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2804, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2480, 44),
      ))
    }

@delegate:ResourceContentHash(342_589_094)
internal val Res.string.business_filter_price: StringResource by lazy {
      StringResource("string:business_filter_price", "business_filter_price", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 3513, 41),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2861, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2525, 37),
      ))
    }

@delegate:ResourceContentHash(-1_412_702_537)
internal val Res.string.business_filter_top_rated: StringResource by lazy {
      StringResource("string:business_filter_top_rated", "business_filter_top_rated", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 3555, 73),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2899, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2563, 45),
      ))
    }

@delegate:ResourceContentHash(-1_629_967_821)
internal val Res.string.business_filter_verified: StringResource by lazy {
      StringResource("string:business_filter_verified", "business_filter_verified", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 3629, 56),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2949, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2609, 44),
      ))
    }

@delegate:ResourceContentHash(1_241_412_880)
internal val Res.string.business_follow: StringResource by lazy {
      StringResource("string:business_follow", "business_follow", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 3749, 51),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3037, 31),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2693, 31),
      ))
    }

@delegate:ResourceContentHash(1_976_169_267)
internal val Res.string.business_following: StringResource by lazy {
      StringResource("string:business_following", "business_following", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 3686, 62),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2998, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2654, 38),
      ))
    }

@delegate:ResourceContentHash(-369_582_825)
internal val Res.string.business_hours_closed: StringResource by lazy {
      StringResource("string:business_hours_closed", "business_hours_closed", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 3801, 45),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3069, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2725, 37),
      ))
    }

@delegate:ResourceContentHash(-1_644_632_772)
internal val Res.string.business_listing_request_done: StringResource by lazy {
      StringResource("string:business_listing_request_done", "business_listing_request_done", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 3847, 57),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3107, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2763, 45),
      ))
    }

@delegate:ResourceContentHash(1_655_421_015)
internal val Res.string.business_listing_request_email_label: StringResource by lazy {
      StringResource("string:business_listing_request_email_label", "business_listing_request_email_label", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 3905, 92),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3157, 80),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2809, 72),
      ))
    }

@delegate:ResourceContentHash(-1_130_634_320)
internal val Res.string.business_listing_request_failed: StringResource by lazy {
      StringResource("string:business_listing_request_failed", "business_listing_request_failed", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 3998, 167),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3238, 123),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2882, 119),
      ))
    }

@delegate:ResourceContentHash(-162_624_500)
internal val Res.string.business_listing_request_link: StringResource by lazy {
      StringResource("string:business_listing_request_link", "business_listing_request_link", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 4166, 153),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3362, 117),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3002, 105),
      ))
    }

@delegate:ResourceContentHash(-1_633_331_761)
internal val Res.string.business_listing_request_message_label: StringResource by lazy {
      StringResource("string:business_listing_request_message_label", "business_listing_request_message_label", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 4320, 94),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3480, 78),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3108, 70),
      ))
    }

@delegate:ResourceContentHash(-1_216_055_507)
internal val Res.string.business_listing_request_message_placeholder: StringResource by lazy {
      StringResource("string:business_listing_request_message_placeholder", "business_listing_request_message_placeholder", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 4415, 256),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3559, 192),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3179, 172),
      ))
    }

@delegate:ResourceContentHash(1_680_436_657)
internal val Res.string.business_listing_request_sent: StringResource by lazy {
      StringResource("string:business_listing_request_sent", "business_listing_request_sent", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 4672, 213),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3752, 165),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3352, 133),
      ))
    }

@delegate:ResourceContentHash(-1_130_318_305)
internal val Res.string.business_listing_request_submit: StringResource by lazy {
      StringResource("string:business_listing_request_submit", "business_listing_request_submit", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 4886, 75),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3918, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3486, 55),
      ))
    }

@delegate:ResourceContentHash(-1_589_109_053)
internal val Res.string.business_listing_request_subtitle: StringResource by lazy {
      StringResource("string:business_listing_request_subtitle", "business_listing_request_subtitle", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 4962, 197),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3982, 153),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3542, 137),
      ))
    }

@delegate:ResourceContentHash(1_507_516_978)
internal val Res.string.business_listing_request_title: StringResource by lazy {
      StringResource("string:business_listing_request_title", "business_listing_request_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 5160, 94),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4136, 82),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3680, 78),
      ))
    }

@delegate:ResourceContentHash(-424_576_996)
internal val Res.string.business_listing_request_type_correction: StringResource by lazy {
      StringResource("string:business_listing_request_type_correction", "business_listing_request_type_correction", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 5255, 84),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4219, 80),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3759, 68),
      ))
    }

@delegate:ResourceContentHash(-561_750_232)
internal val Res.string.business_listing_request_type_privacy: StringResource by lazy {
      StringResource("string:business_listing_request_type_privacy", "business_listing_request_type_privacy", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 5340, 89),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4300, 85),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3828, 65),
      ))
    }

@delegate:ResourceContentHash(-1_508_796_775)
internal val Res.string.business_listing_request_type_removal: StringResource by lazy {
      StringResource("string:business_listing_request_type_removal", "business_listing_request_type_removal", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 5430, 69),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4386, 69),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3894, 65),
      ))
    }

@delegate:ResourceContentHash(-849_691_147)
internal val Res.string.business_no_reviews_header: StringResource by lazy {
      StringResource("string:business_no_reviews_header", "business_no_reviews_header", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 5500, 146),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4456, 134),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3960, 90),
      ))
    }

@delegate:ResourceContentHash(49_572_467)
internal val Res.string.business_open_now: StringResource by lazy {
      StringResource("string:business_open_now", "business_open_now", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 5647, 45),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4591, 33),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4051, 37),
      ))
    }

@delegate:ResourceContentHash(1_596_659_142)
internal val Res.string.business_opens: StringResource by lazy {
      StringResource("string:business_opens", "business_opens", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 5760, 58),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4676, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4136, 38),
      ))
    }

@delegate:ResourceContentHash(-1_325_414_052)
internal val Res.string.business_opens_day: StringResource by lazy {
      StringResource("string:business_opens_day", "business_opens_day", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 5693, 66),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4625, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4089, 46),
      ))
    }

@delegate:ResourceContentHash(2_057_853_006)
internal val Res.string.business_owner_reply: StringResource by lazy {
      StringResource("string:business_owner_reply", "business_owner_reply", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 5819, 64),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4719, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4175, 60),
      ))
    }

@delegate:ResourceContentHash(-442_107_383)
internal val Res.string.business_photo_a11y: StringResource by lazy {
      StringResource("string:business_photo_a11y", "business_photo_a11y", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 5884, 59),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4780, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4236, 47),
      ))
    }

@delegate:ResourceContentHash(-52_537_313)
internal val Res.string.business_pro_badge: StringResource by lazy {
      StringResource("string:business_pro_badge", "business_pro_badge", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 5944, 34),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4836, 30),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4284, 30),
      ))
    }

@delegate:ResourceContentHash(1_817_050_574)
internal val Res.string.business_rating_a11y: StringResource by lazy {
      StringResource("string:business_rating_a11y", "business_rating_a11y", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 5979, 80),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4867, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4315, 72),
      ))
    }

@delegate:ResourceContentHash(-323_565_078)
internal val Res.string.business_rating_reviews: StringResource by lazy {
      StringResource("string:business_rating_reviews", "business_rating_reviews", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 6060, 63),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4932, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4388, 59),
      ))
    }

@delegate:ResourceContentHash(-975_695_675)
internal val Res.string.business_report: StringResource by lazy {
      StringResource("string:business_report", "business_report", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 6124, 75),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4988, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4448, 63),
      ))
    }

@delegate:ResourceContentHash(-2_029_959_231)
internal val Res.string.business_retry: StringResource by lazy {
      StringResource("string:business_retry", "business_retry", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 6200, 50),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5060, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4512, 34),
      ))
    }

@delegate:ResourceContentHash(-997_827_542)
internal val Res.string.business_review_nudge_desc: StringResource by lazy {
      StringResource("string:business_review_nudge_desc", "business_review_nudge_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 6251, 274),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5099, 198),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4547, 170),
      ))
    }

@delegate:ResourceContentHash(2_037_158_178)
internal val Res.string.business_review_nudge_dismiss_a11y: StringResource by lazy {
      StringResource("string:business_review_nudge_dismiss_a11y", "business_review_nudge_dismiss_a11y", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 6526, 94),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5298, 94),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4718, 70),
      ))
    }

@delegate:ResourceContentHash(-1_269_652_061)
internal val Res.string.business_review_nudge_title: StringResource by lazy {
      StringResource("string:business_review_nudge_title", "business_review_nudge_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 6621, 87),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5393, 75),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4789, 63),
      ))
    }

@delegate:ResourceContentHash(-401_080_438)
internal val Res.string.business_reviews_empty: StringResource by lazy {
      StringResource("string:business_reviews_empty", "business_reviews_empty", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 6709, 186),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5469, 138),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4853, 106),
      ))
    }

@delegate:ResourceContentHash(772_191_497)
internal val Res.string.business_save_a11y: StringResource by lazy {
      StringResource("string:business_save_a11y", "business_save_a11y", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 6896, 42),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5608, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4960, 34),
      ))
    }

@delegate:ResourceContentHash(-1_939_862_748)
internal val Res.string.business_saved_a11y: StringResource by lazy {
      StringResource("string:business_saved_a11y", "business_saved_a11y", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 6939, 55),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5651, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4995, 35),
      ))
    }

@delegate:ResourceContentHash(1_234_592_299)
internal val Res.string.business_section_about: StringResource by lazy {
      StringResource("string:business_section_about", "business_section_about", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 6995, 46),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5695, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5031, 38),
      ))
    }

@delegate:ResourceContentHash(-2_076_811_050)
internal val Res.string.business_section_amenities: StringResource by lazy {
      StringResource("string:business_section_amenities", "business_section_amenities", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 7042, 54),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5738, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5070, 46),
      ))
    }

@delegate:ResourceContentHash(-965_601_210)
internal val Res.string.business_section_hours: StringResource by lazy {
      StringResource("string:business_section_hours", "business_section_hours", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 7097, 58),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5789, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5117, 38),
      ))
    }

@delegate:ResourceContentHash(-1_143_550_147)
internal val Res.string.business_section_nearby: StringResource by lazy {
      StringResource("string:business_section_nearby", "business_section_nearby", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 7156, 59),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5828, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5156, 51),
      ))
    }

@delegate:ResourceContentHash(923_613_815)
internal val Res.string.business_section_photos: StringResource by lazy {
      StringResource("string:business_section_photos", "business_section_photos", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 7216, 51),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5892, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5208, 39),
      ))
    }

@delegate:ResourceContentHash(-463_565_511)
internal val Res.string.business_section_recommended: StringResource by lazy {
      StringResource("string:business_section_recommended", "business_section_recommended", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 7268, 60),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5932, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5248, 52),
      ))
    }

@delegate:ResourceContentHash(-1_842_427_983)
internal val Res.string.business_section_reviews: StringResource by lazy {
      StringResource("string:business_section_reviews", "business_section_reviews", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 7329, 48),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5985, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5301, 44),
      ))
    }

@delegate:ResourceContentHash(1_431_215_964)
internal val Res.string.business_share_a11y: StringResource by lazy {
      StringResource("string:business_share_a11y", "business_share_a11y", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 7378, 51),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6026, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5346, 35),
      ))
    }

@delegate:ResourceContentHash(780_390_351)
internal val Res.string.business_share_message: StringResource by lazy {
      StringResource("string:business_share_message", "business_share_message", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 7430, 86),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6066, 78),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5382, 74),
      ))
    }

@delegate:ResourceContentHash(1_896_734_237)
internal val Res.string.business_sponsored: StringResource by lazy {
      StringResource("string:business_sponsored", "business_sponsored", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 7517, 54),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6145, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5457, 38),
      ))
    }

@delegate:ResourceContentHash(-434_120_505)
internal val Res.string.business_verified: StringResource by lazy {
      StringResource("string:business_verified", "business_verified", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 7651, 49),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6247, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5551, 37),
      ))
    }

@delegate:ResourceContentHash(-536_282_099)
internal val Res.string.business_verified_a11y: StringResource by lazy {
      StringResource("string:business_verified_a11y", "business_verified_a11y", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 7572, 78),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6188, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5496, 54),
      ))
    }

@delegate:ResourceContentHash(-359_391_774)
internal val Res.string.business_write_review: StringResource by lazy {
      StringResource("string:business_write_review", "business_write_review", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 7701, 53),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6285, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5589, 49),
      ))
    }

@delegate:ResourceContentHash(-74_719_876)
internal val Res.string.claim_back_a11y: StringResource by lazy {
      StringResource("string:claim_back_a11y", "claim_back_a11y", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 7755, 39),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6339, 31),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5639, 31),
      ))
    }

@delegate:ResourceContentHash(-126_824_420)
internal val Res.string.claim_business_header: StringResource by lazy {
      StringResource("string:claim_business_header", "claim_business_header", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 7795, 89),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6371, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5671, 57),
      ))
    }

@delegate:ResourceContentHash(-810_208_148)
internal val Res.string.claim_email_label: StringResource by lazy {
      StringResource("string:claim_email_label", "claim_email_label", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 7885, 53),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6429, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5729, 45),
      ))
    }

@delegate:ResourceContentHash(-317_064_370)
internal val Res.string.claim_email_placeholder: StringResource by lazy {
      StringResource("string:claim_email_placeholder", "claim_email_placeholder", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 7939, 51),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6483, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5775, 51),
      ))
    }

@delegate:ResourceContentHash(116_778_531)
internal val Res.string.claim_error_email: StringResource by lazy {
      StringResource("string:claim_error_email", "claim_error_email", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 7991, 85),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6539, 73),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5827, 61),
      ))
    }

@delegate:ResourceContentHash(247_460_581)
internal val Res.string.claim_error_phone: StringResource by lazy {
      StringResource("string:claim_error_phone", "claim_error_phone", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 8077, 97),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6613, 77),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5889, 61),
      ))
    }

@delegate:ResourceContentHash(-583_652_916)
internal val Res.string.claim_error_required: StringResource by lazy {
      StringResource("string:claim_error_required", "claim_error_required", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 8175, 76),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6691, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5951, 60),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString0Resources(map: MutableMap<String, StringResource>) {
  map.put("all_photos_empty", Res.string.all_photos_empty)
  map.put("all_photos_title", Res.string.all_photos_title)
  map.put("all_reviews_count", Res.string.all_reviews_count)
  map.put("all_reviews_sort_highest", Res.string.all_reviews_sort_highest)
  map.put("all_reviews_sort_lowest", Res.string.all_reviews_sort_lowest)
  map.put("all_reviews_sort_recent", Res.string.all_reviews_sort_recent)
  map.put("all_reviews_title", Res.string.all_reviews_title)
  map.put("biz_lang_arabic", Res.string.biz_lang_arabic)
  map.put("biz_lang_english", Res.string.biz_lang_english)
  map.put("biz_lang_french", Res.string.biz_lang_french)
  map.put("biz_lang_persian", Res.string.biz_lang_persian)
  map.put("business_action_call", Res.string.business_action_call)
  map.put("business_action_chat", Res.string.business_action_chat)
  map.put("business_action_details", Res.string.business_action_details)
  map.put("business_action_directions", Res.string.business_action_directions)
  map.put("business_action_see_all", Res.string.business_action_see_all)
  map.put("business_action_view_all", Res.string.business_action_view_all)
  map.put("business_action_view_menu", Res.string.business_action_view_menu)
  map.put("business_action_website", Res.string.business_action_website)
  map.put("business_add_listing_a11y", Res.string.business_add_listing_a11y)
  map.put("business_address_approx", Res.string.business_address_approx)
  map.put("business_back_a11y", Res.string.business_back_a11y)
  map.put("business_badge_new", Res.string.business_badge_new)
  map.put("business_call_a11y", Res.string.business_call_a11y)
  map.put("business_channel", Res.string.business_channel)
  map.put("business_claim_cta", Res.string.business_claim_cta)
  map.put("business_claim_desc", Res.string.business_claim_desc)
  map.put("business_claim_failed", Res.string.business_claim_failed)
  map.put("business_claim_sent", Res.string.business_claim_sent)
  map.put("business_claim_title", Res.string.business_claim_title)
  map.put("business_claim_verified_cta", Res.string.business_claim_verified_cta)
  map.put("business_claim_verified_desc", Res.string.business_claim_verified_desc)
  map.put("business_claim_verified_title", Res.string.business_claim_verified_title)
  map.put("business_closed", Res.string.business_closed)
  map.put("business_closes", Res.string.business_closes)
  map.put("business_cover_a11y", Res.string.business_cover_a11y)
  map.put("business_directions_a11y", Res.string.business_directions_a11y)
  map.put("business_distance_km", Res.string.business_distance_km)
  map.put("business_distance_m", Res.string.business_distance_m)
  map.put("business_empty", Res.string.business_empty)
  map.put("business_error", Res.string.business_error)
  map.put("business_favorite_a11y", Res.string.business_favorite_a11y)
  map.put("business_filter_nearby", Res.string.business_filter_nearby)
  map.put("business_filter_open_now", Res.string.business_filter_open_now)
  map.put("business_filter_price", Res.string.business_filter_price)
  map.put("business_filter_top_rated", Res.string.business_filter_top_rated)
  map.put("business_filter_verified", Res.string.business_filter_verified)
  map.put("business_follow", Res.string.business_follow)
  map.put("business_following", Res.string.business_following)
  map.put("business_hours_closed", Res.string.business_hours_closed)
  map.put("business_listing_request_done", Res.string.business_listing_request_done)
  map.put("business_listing_request_email_label", Res.string.business_listing_request_email_label)
  map.put("business_listing_request_failed", Res.string.business_listing_request_failed)
  map.put("business_listing_request_link", Res.string.business_listing_request_link)
  map.put("business_listing_request_message_label", Res.string.business_listing_request_message_label)
  map.put("business_listing_request_message_placeholder", Res.string.business_listing_request_message_placeholder)
  map.put("business_listing_request_sent", Res.string.business_listing_request_sent)
  map.put("business_listing_request_submit", Res.string.business_listing_request_submit)
  map.put("business_listing_request_subtitle", Res.string.business_listing_request_subtitle)
  map.put("business_listing_request_title", Res.string.business_listing_request_title)
  map.put("business_listing_request_type_correction", Res.string.business_listing_request_type_correction)
  map.put("business_listing_request_type_privacy", Res.string.business_listing_request_type_privacy)
  map.put("business_listing_request_type_removal", Res.string.business_listing_request_type_removal)
  map.put("business_no_reviews_header", Res.string.business_no_reviews_header)
  map.put("business_open_now", Res.string.business_open_now)
  map.put("business_opens", Res.string.business_opens)
  map.put("business_opens_day", Res.string.business_opens_day)
  map.put("business_owner_reply", Res.string.business_owner_reply)
  map.put("business_photo_a11y", Res.string.business_photo_a11y)
  map.put("business_pro_badge", Res.string.business_pro_badge)
  map.put("business_rating_a11y", Res.string.business_rating_a11y)
  map.put("business_rating_reviews", Res.string.business_rating_reviews)
  map.put("business_report", Res.string.business_report)
  map.put("business_retry", Res.string.business_retry)
  map.put("business_review_nudge_desc", Res.string.business_review_nudge_desc)
  map.put("business_review_nudge_dismiss_a11y", Res.string.business_review_nudge_dismiss_a11y)
  map.put("business_review_nudge_title", Res.string.business_review_nudge_title)
  map.put("business_reviews_empty", Res.string.business_reviews_empty)
  map.put("business_save_a11y", Res.string.business_save_a11y)
  map.put("business_saved_a11y", Res.string.business_saved_a11y)
  map.put("business_section_about", Res.string.business_section_about)
  map.put("business_section_amenities", Res.string.business_section_amenities)
  map.put("business_section_hours", Res.string.business_section_hours)
  map.put("business_section_nearby", Res.string.business_section_nearby)
  map.put("business_section_photos", Res.string.business_section_photos)
  map.put("business_section_recommended", Res.string.business_section_recommended)
  map.put("business_section_reviews", Res.string.business_section_reviews)
  map.put("business_share_a11y", Res.string.business_share_a11y)
  map.put("business_share_message", Res.string.business_share_message)
  map.put("business_sponsored", Res.string.business_sponsored)
  map.put("business_verified", Res.string.business_verified)
  map.put("business_verified_a11y", Res.string.business_verified_a11y)
  map.put("business_write_review", Res.string.business_write_review)
  map.put("claim_back_a11y", Res.string.claim_back_a11y)
  map.put("claim_business_header", Res.string.claim_business_header)
  map.put("claim_email_label", Res.string.claim_email_label)
  map.put("claim_email_placeholder", Res.string.claim_email_placeholder)
  map.put("claim_error_email", Res.string.claim_error_email)
  map.put("claim_error_phone", Res.string.claim_error_phone)
  map.put("claim_error_required", Res.string.claim_error_required)
}
